// Imports

import thunk from 'redux-thunk';
import { applyMiddleware } from 'redux';

// Export

export default applyMiddleware(thunk);
